import _objectWithoutProperties from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { Field } from 'redux-form';
import { getCustomStyles, mapValidation } from '@defi/core-utils';
import { withStyles } from '@material-ui/core/styles';
import TextFieldMasked from '../form/material/v4/TextFieldMasked';
var styles = {
  truncate: {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  hide: {
    display: 'none'
  },
  default: {
    // height: 'auto',
    width: '100%',
    '& input': {
      padding: '3px',
      color: '#000',
      fontSize: '12px',
      height: 14
    },
    '& textarea': {
      padding: '3px',
      color: '#000',
      fontSize: 12,
      margin: '0 0 -7px 0',
      paddingTop: 1
    },
    '& p': {
      color: 'red',
      margin: '2px 0'
    }
  },
  edit: {
    '& input, & textarea': {
      border: '1px solid #ccc',
      backgroundColor: '#fff'
    }
  },
  disabled: {
    '& textarea': {
      padding: '3px 4px 4px 4px'
    }
  },
  error: {
    '& input': {
      border: '1px solid red',
      marginTop: 5
    }
  }
};

var TextInput =
/*#__PURE__*/
function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      value: _this.props.children.get('Value')
    };
    _this.reachedMax = _this.props.children.get('Value').length === _this.props.children.getIn(['DataElement', 'FieldLength']);

    _this.handleOnKeyUp = function (e) {
      if (e.target.value.length === _this.props.fieldLength) {
        if (e.key !== 'Tab') {
          if (_this.reachedMax) {
            _this.props.toggleSnackbar(true, 'You have reached the maximum length of this input field', 'red');
          } else {
            _this.reachedMax = true;
          }
        }
      } else {
        _this.reachedMax = false;
      }
    };

    return _this;
  }

  _createClass(TextInput, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.handleChangeRequirement(this.props.children.get('Value'));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.editStatus && this.props.validation.length > 0) {
        if (!this.props.open) {
          this.props.toggleSection(true);
        }
      }
    }
  }, {
    key: "getClasses",
    value: function getClasses() {
      var _this$props = this.props,
          classes = _this$props.classes,
          editStatus = _this$props.editStatus;
      var statusClass = editStatus ? classes.edit : classes.disabled;
      return "".concat(classes.default, " ").concat(statusClass);
    }
  }, {
    key: "handleChangeRequirement",
    value: function handleChangeRequirement(value) {
      this.props.changeRequirement(value, this.props.residencyDurationInYears, this.props.employmentDurationInYears);
    }
  }, {
    key: "render",
    // renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => {
    //   return (
    //     <InputMasked
    //       InputProps={{ disableUnderline: true }}
    //       id={String(this.props.children.get('ElementId'))}
    //       maxLength={this.props.children.getIn(['DataElement', 'FieldLength'])}
    //       mask={this.props.children.get('Mask')}
    //       disabled={this.props.disabled}
    //       multiline={this.props.children.get('IsExpandable')}
    //       className={
    //         `${this.getClasses()} ${touched && error ? this.props.classes.errorText : ''} ${this.props.disabled ? this.props.classes.hide : ''}`
    //       }
    //       helperText={touched && error}
    //       {...input}
    //       {...custom}
    //     />
    //   );
    // };
    //   render() {
    //     const customStyles = getCustomStyles(this.props.format);
    //     const { children, classes } = this.props;
    //     return (
    //       <div className={classes.truncate}>
    //         <span title={this.state.value} style={this.props.disabled ? customStyles : { display: 'none' }}>
    //           {children.get('IsExpandable')
    //             ? this.state.value
    //               .split('\n')
    //               .map((section, i) => <div key={i}>{section}</div>)
    //             : this.state.value}
    //         </span>
    //         <Field
    //           id={String(children.get('ElementId'))}
    //           name={String(children.get('DataElement').get('Id'))}
    //           component={this.renderTextField}
    //           onKeyUp={this.handleOnKeyUp}
    //           validate={this.props.validation}
    //           onBlur={e => this.handleChangeRequirement(e.target.value)}
    //         />
    //       </div>
    //     );
    //   }
    // }
    value: function render() {
      var _this2 = this;

      var customStyles = getCustomStyles(this.props.format); // const { classes, context } = this.props;

      var _this$props2 = this.props,
          context = _this$props2.context,
          classes = _this$props2.classes,
          name = _this$props2.name,
          mask = _this$props2.mask,
          other = _objectWithoutProperties(_this$props2, ["context", "classes", "name", "mask"]); // const renderTextField = ({
      //   input,
      //   label,
      //   meta: { touched, error },
      //   ...custom
      // }) => (
      //     <InputMasked
      //       InputProps={{
      //         disableUnderline: true,
      //       }}
      //       id={this.props.id}
      //       maxLength={this.props.fieldLength}
      //       mask={this.props.mask}
      //       disabled={this.props.disabled}
      //       multiline={this.props.expandable}
      //       className={
      //         `${this.getClasses()} ${touched && error ? classes.error : ''} ${this.props.disabled ? classes.hide : ''}`
      //       }
      //       style={
      //         this.props.disabled ? { display: 'none' } : { display: 'inline' }
      //       }
      //       helperText={touched && error}
      //       {...input}
      //       {...custom}
      //       context={context}
      //     />
      //   );


      return React.createElement("div", {
        className: classes.truncate
      }, React.createElement("span", {
        title: this.state.value,
        style: this.props.disabled ? customStyles : {
          display: 'none'
        }
      }, this.props.expandable ? this.state.value.split('\n').map(function (section, i) {
        return React.createElement("div", {
          key: i
        }, section);
      }) : this.state.value), React.createElement(Field, Object.assign({
        context: context,
        name: name,
        mask: mask ? mask.toJS() : {
          hasMask: false
        },
        component: TextFieldMasked,
        onKeyUp: this.handleOnKeyUp,
        required: this.props.required,
        validate: this.props.validation,
        fullWidth: this.props.fullWidth,
        margin: this.props.margin,
        variant: "outlined",
        labelShrink: true,
        onBlur: function onBlur(e) {
          return _this2.handleChangeRequirement(_this2.props.dataElementName, e.target.value);
        },
        ref: this.saveRef,
        forwardRef: true
      }, other)));
    }
  }]);

  return TextInput;
}(Component);

export default withStyles(styles)(TextInput);